import { render, staticRenderFns } from "./AiBadge.vue?vue&type=template&id=470eb545&scoped=true"
import script from "./AiBadge.vue?vue&type=script&lang=js"
export * from "./AiBadge.vue?vue&type=script&lang=js"
import style0 from "./AiBadge.vue?vue&type=style&index=0&id=470eb545&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470eb545",
  null
  
)

export default component.exports